import { render } from "./WelcomeSection.vue?vue&type=template&id=75ff6729&scoped=true"
const script = {}

import "./WelcomeSection.vue?vue&type=style&index=0&id=75ff6729&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ff6729"]])

export default __exports__